import { getAuth } from 'firebase/auth';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { toast } from 'src/components/snackbar';
import { getFirestore } from 'firebase/firestore';
import { CONFIG } from 'src/config-global';
const isFirebase = CONFIG.auth.method === 'firebase';

export const firebaseApp = isFirebase ? initializeApp(CONFIG.firebase) : {};

export const AUTH = isFirebase ? getAuth(firebaseApp) : {};

export const FIRESTORE = isFirebase ? getFirestore(firebaseApp) : {};

const firebaseConfig = {
  apiKey: 'AIzaSyCdIPv5M0mUooxPbM5v5YiCARI2EIlPb7E',
  authDomain: 'tairra-7f828.firebaseapp.com',
  databaseURL: 'https://tairra-7f828-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'tairra-7f828',
  storageBucket: 'tairra-7f828.firebasestorage.app',
  messagingSenderId: '841623012349',
  appId: '1:841623012349:web:b4842a30dcc9ac26f5cf94',
  measurementId: 'G-BL6WJX9K11',
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js')
    .then((registration) => {
      console.log('');
    })
    .catch((error) => {
      console.error('Service Worker Registration Failed:', error);
    });
}

export const requestPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    console.log('status of permission', permission);
    if (permission === 'denied') {
      toast.success('Firebase Notification permission denied.');
      console.log('Firebase Notification permission denied.');
    }

    if (permission === 'granted') {
      console.log('Notification permission granted.');
      toast.success('Firebase Notification permission granted.');
      const token = await getToken(messaging, {
        vapidKey:
          'BJaF1QTALGRNJeU5XOlUTSga1G1h7ERAFJA_kYfPZHNK80L19V3UUuJxHN-YCQ2nLp46lr2NHow74ruaNBm9nJ8',
      });

      if (token) {
        localStorage.setItem('fireMessageToken', token);
        console.log('FCM Token Saved:', token);
      } else {
        console.warn('No FCM token received.');
      }
    } else {
      console.warn('Notification permission denied.');
    }
  } catch (error) {
    console.error('Error getting FCM token:', error);
  }
};

export const onMessageListener = () => {
  return new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log('Message Received:', payload);
      toast.info(payload?.notification?.body, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      resolve(payload);
    });
  });
};
